import { OrderStatesGridView } from '~/components/order/order-states';
import { PageContainer } from '~/components/page-container';

export function OrderStates() {
	return (
		<PageContainer>
			<OrderStatesGridView />
		</PageContainer>
	);
}
